import React, { FC } from "react"
import {
    FooterWrapper,
    ImageWrapper,
    InnerWrapper,
    LinkWrapper,
    LogoWrapper,
    StyledLink,
    StyledSpan
} from "@components/Footer/styles"
import { Subtitle, Title } from "@components/styles"
import getPageLink from "@utils/getPageLink"
import type { FooterProps } from "./types"

const year = (new Date()).getFullYear()

const Footer: FC<FooterProps> = ({
    subtitle,
    title,
    image,
    links,
    logo
}) => {
    return <FooterWrapper>
        <InnerWrapper>
            <Subtitle>{subtitle}</Subtitle>
            <Title css={{ maxWidth: 625 }}>{title}</Title>
            <LinkWrapper>
                <StyledSpan>
                    {year}
                    {" "}
                    Play Unified
                </StyledSpan>
                {links.map((item) => (
                    <StyledLink key={`${item.title}`} to={getPageLink(item?.page) || item.direct_url}>
                        {item.title}
                    </StyledLink>
                ))}
                <LogoWrapper>
                    {logo}
                </LogoWrapper>
            </LinkWrapper>
        </InnerWrapper>
        <ImageWrapper>
            {image}
        </ImageWrapper>
    </FooterWrapper>
}

export default Footer
